import { Box, Chip, Grid } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./customOrderStyle.css";
import { Commande } from "../slices/orderSlice";
import { formatPrice } from "../../../utils/formatPrice";

interface CustomOrderProps {
  order: Commande;
  isSelected: boolean;
  onClick: () => void;
}

const statusColors: { [key: string]: string } = {
  "Validée": "#28a745",
  "En livraison": "#007bff",
  "Créée": "#ffc107",
  "En cours": "#17a2b8",
  "Pending": "#17a2b8",
  "Created": "#ffc107",
  "Validated": "#28a745",
  "Canceled": "#17a2b8",
};

const CustomOrder: React.FC<CustomOrderProps> = ({ order, isSelected, onClick }) => {
  const getStatusColor = (status: string) => {
    return statusColors[status] || "#000"; 
  };

  return (
    <Grid
      container
      p={2}
      sx={{
        border: "0.5px solid #F9F9F9",
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        marginBottom: "3%",
        cursor: "pointer",
        backgroundColor: isSelected ? "#f0f0f0" : "white",
      }}
      onClick={onClick}
    >
      <Grid item xs={11}>
        <Grid container>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
              mt={1}
              mb={1}
            >
              <span className="label-title">N° : </span>
              <span className="title">{order.NumeroCommande}</span>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center", 
              }}
              mt={1}
              mb={1}
            >
              <span className="label-title">N° Client : </span>
              <span className="title">{order.NumeroClient ? order.NumeroClient : "-"}</span>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center", 
              }}
              mt={1}
              mb={1}
            >
              <span className="label-title">Nom Client : </span>
              <span className="title">{order.NomClient ? order.NomClient : "-"}</span>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
              mt={1}
              mb={1}
            >
              <span className="label-title">Date : </span>
              <span className="title">{new Date(order.DateCommande).toLocaleDateString()}</span>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <span className="label-title">Montant : </span>
              <span className="title">{formatPrice(order.MontantTTC)} MAD</span>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",

              }}
              mt={1}
              mb={1}
            >
              <span className="label-title">Statut : </span>
              <Chip
                sx={{ backgroundColor: getStatusColor(order.StatutFinal), color: "white" , marginLeft:'5px'}}
                size="small"
                label={order.StatutFinal}
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ArrowForwardIosIcon fontSize="small" />
      </Grid>
    </Grid>
  );
};

export default CustomOrder;
